<svg
  id="ejzpSyTNhRG1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 400 400"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  width="400"
  height="400"
>
  <g id="ejzpSyTNhRG2_ts" transform="translate(199.92791,212.349998) scale(1,1)">
    <g id="ejzpSyTNhRG2" transform="translate(-199.92791,-212.349998)" opacity="0">
      <g>
        <path
          d="M303.2,174.8v0c0-.7,0-1.4,0-2.1c0-28.7-24.2-53.6-54.1-53.6-21.8,0-40.6,9.2-49.2,27.1v0c-8.5-17.9-27.3-27.1-49.2-27.1-29.9,0-54.1,24.9-54.1,53.6c0,.7,0,1.4.1,2.1v0c0,0-3.1,34.1,34.9,71.3c17.3,17.3,36.5,33.7,68.3,59.5c31.8-25.8,51-42.2,68.3-59.5c38-37.2,35-71.3,35-71.3Z"
          fill="none"
          stroke="#cf1b39"
          stroke-width="1.8143"
          stroke-miterlimit="10"
        />
      </g>
    </g>
  </g>
  <g id="ejzpSyTNhRG5_ts" transform="translate(199.92791,212.349998) scale(1,1)">
    <g id="ejzpSyTNhRG5" transform="translate(-199.92791,-212.349998)" opacity="0">
      <g>
        <path
          d="M303.2,174.8v0c0-.7,0-1.4,0-2.1c0-28.7-24.2-53.6-54.1-53.6-21.8,0-40.6,9.2-49.2,27.1v0c-8.5-17.9-27.3-27.1-49.2-27.1-29.9,0-54.1,24.9-54.1,53.6c0,.7,0,1.4.1,2.1v0c0,0-3.1,34.1,34.9,71.3c17.3,17.3,36.5,33.7,68.3,59.5c31.8-25.8,51-42.2,68.3-59.5c38-37.2,35-71.3,35-71.3Z"
          fill="none"
          stroke="#cf1b39"
          stroke-width="1.8143"
          stroke-miterlimit="10"
        />
      </g>
    </g>
  </g>
  <g id="ejzpSyTNhRG8_ts" transform="translate(199.92791,212.349998) scale(1,1)">
    <g id="ejzpSyTNhRG8" transform="translate(-199.92791,-212.349998)" opacity="0">
      <g>
        <path
          d="M303.2,174.8v0c0-.7,0-1.4,0-2.1c0-28.7-24.2-53.6-54.1-53.6-21.8,0-40.6,9.2-49.2,27.1v0c-8.5-17.9-27.3-27.1-49.2-27.1-29.9,0-54.1,24.9-54.1,53.6c0,.7,0,1.4.1,2.1v0c0,0-3.1,34.1,34.9,71.3c17.3,17.3,36.5,33.7,68.3,59.5c31.8-25.8,51-42.2,68.3-59.5c38-37.2,35-71.3,35-71.3Z"
          fill="none"
          stroke="#cf1b39"
          stroke-width="1.8143"
          stroke-miterlimit="10"
        />
      </g>
    </g>
  </g>
  <g id="ejzpSyTNhRG11_ts" transform="translate(199.92791,212.349998) scale(1,1)">
    <g id="ejzpSyTNhRG11" transform="translate(-199.92791,-212.349998)" opacity="0">
      <g>
        <path
          d="M303.2,174.8v0c0-.7,0-1.4,0-2.1c0-28.7-24.2-53.6-54.1-53.6-21.8,0-40.6,9.2-49.2,27.1v0c-8.5-17.9-27.3-27.1-49.2-27.1-29.9,0-54.1,24.9-54.1,53.6c0,.7,0,1.4.1,2.1v0c0,0-3.1,34.1,34.9,71.3c17.3,17.3,36.5,33.7,68.3,59.5c31.8-25.8,51-42.2,68.3-59.5c38-37.2,35-71.3,35-71.3Z"
          fill="none"
          stroke="#cf1b39"
          stroke-width="1.8143"
          stroke-miterlimit="10"
        />
      </g>
    </g>
  </g>
  <g id="ejzpSyTNhRG14_ts" transform="translate(199.92791,212.349998) scale(1,1)">
    <g id="ejzpSyTNhRG14" transform="translate(-199.92791,-212.349998)" opacity="0">
      <g>
        <path
          d="M303.2,174.8v0c0-.7,0-1.4,0-2.1c0-28.7-24.2-53.6-54.1-53.6-21.8,0-40.6,9.2-49.2,27.1v0c-8.5-17.9-27.3-27.1-49.2-27.1-29.9,0-54.1,24.9-54.1,53.6c0,.7,0,1.4.1,2.1v0c0,0-3.1,34.1,34.9,71.3c17.3,17.3,36.5,33.7,68.3,59.5c31.8-25.8,51-42.2,68.3-59.5c38-37.2,35-71.3,35-71.3Z"
          fill="none"
          stroke="#cf1b39"
          stroke-width="1.8143"
          stroke-miterlimit="10"
        />
      </g>
    </g>
  </g>
  <g id="ejzpSyTNhRG17_ts" transform="translate(199.927894,212.349998) scale(0,0)">
    <g transform="translate(-199.927894,-212.349998)">
      <g>
        <g>
          <path
            d="M303.2,174.8v0c0-.7,0-1.4,0-2.1c0-28.7-24.2-53.6-54.1-53.6-21.8,0-40.6,9.2-49.2,27.1v0c-8.5-17.9-27.3-27.1-49.2-27.1-29.9,0-54.1,24.9-54.1,53.6c0,.7,0,1.4.1,2.1v0c0,0-3.1,34.1,34.9,71.3c17.3,17.3,36.5,33.7,68.3,59.5c31.8-25.8,51-42.2,68.3-59.5c38-37.2,35-71.3,35-71.3Z"
            fill="#cf1b39"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M272.4,188.9v0c0-.5,0-1,0-1.5c0-20.1-17-37.6-37.9-37.6-15.3,0-28.5,9.9-34.5,22.4v0c-6-12.6-19.2-22.4-34.5-22.4-20.9,0-37.9,17.5-37.9,37.6c0,.5,0,1,0,1.5v0c0,0-2.1,23.9,24.5,50.1c12.1,12.1,25.6,23.7,47.9,41.8c22.3-18.1,35.8-29.6,47.9-41.8c26.6-26.1,24.5-50.1,24.5-50.1Z"
            fill="#e63047"
          />
        </g>
      </g>
    </g>
  </g>
</svg>
